import type { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';

export const sortAndFilterRefinementItems = (
  items: RefinementListItem[],
  collectionNames: string[],
) =>
  items
    .filter((item) => {
      if (collectionNames.length) {
        return collectionNames?.includes(item.value);
      }
      return item;
    })
    .sort(({ value: a }, { value: b }) => {
      const aIndex = collectionNames.indexOf(a);
      const bIndex = collectionNames.indexOf(b);

      if (aIndex > bIndex) {
        return 1;
      }

      if (aIndex < bIndex) {
        return -1;
      }

      return 0;
    });
